import { useEffect, useState } from 'react'
import { getCustomerNumber } from '../util'
import { API_ENDPOINTS } from '../../../api'
import { useFetchCustomerData } from './useFetchCustomerData'

export const useGetConsumerDataById = (consumerId) => {
    const customerNumber = getCustomerNumber()
    const apiUrl = API_ENDPOINTS.NAMELIST_VERIFICATION({ customerNumber, consumerId });
    const { data, loading } = useFetchCustomerData(apiUrl)

    return { consumerData: data, consumerDataLoading: loading }
}